<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g>
      <path fill="none" d="M0 0h32v32h-32v-32z" />
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="4"
        stroke-width="1.6"
        d="M6.263 25.664l19.233-19.233"
        class="stroke-current"
      />
      <path
        fill="none"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="4"
        stroke-width="1.6"
        d="M25.496 25.664l-19.233-19.233"
        class="stroke-current"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
